import { render } from "./loadingCom.vue?vue&type=template&id=66591c24"
import script from "./loadingCom.vue?vue&type=script&lang=js"
export * from "./loadingCom.vue?vue&type=script&lang=js"

import "./loadingCom.vue?vue&type=style&index=0&id=66591c24&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__